import { SideNavInterface } from './../interfaces/side-nav.type';

export const ROUTES_club: SideNavInterface[] = [

  {

    path: '/organization_edit_profile',
    title: 'Edit Profile',
    iconType: 'nzIcon',
    icon: '../../../../assets/icon/user-edit.png',
    iconTheme: 'outline',
    submenu: []
  },


  {
    path: '/manageEvents',
    title: 'Manage Events',
    iconType: 'nzIcon',
    icon: '../../../../assets/icon/ME.png',
    iconTheme: 'outline',
    submenu: []
  },
  {
    path: '/manageTeams',
    title: 'Manage Teams',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: '../../../../assets/icon/team-sidenav.png',
    submenu: []
  },
  {
    path: '/paymentReq',
    title: 'Payment Requests',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: '../../../../assets/icon/paymentReq.png',
    submenu: []
  },

  {
    path: '/manageOrders',
    title: 'Manage Orders',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: '../../../../assets/icon/manage-orders.png',
    submenu: []
  },



  {
    path: '/playPromoCodes',
    title: 'Promo Codes',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: '../../../../assets/icon/noun-coupon-4772407 1.png',
    submenu: []
  },



  // {
  //     path: '/manageOrders',
  //     title: 'Manage Orders',
  //     iconType: 'nzIcon',
  //     iconTheme: 'outline',
  //     icon: 'archive',
  //     submenu: []
  // },
  // submenu: [
  //     {
  //         path: '',
  //         title: 'Create',
  //         iconType: 'nzIcon',
  //         icon: 'gold',
  //         iconTheme: 'outline',
  //         submenu: [

  //         ]
  //     },

  // ]
  // },

  {
    path: '/favouriteOrders',
    title: 'Favorite Restaurants',
    iconType: 'nzIcon',
    icon: '../../../../assets/icon/heart.png',
    iconTheme: 'outline',
    submenu: [

    ]
  },

  {
    path: '/cardDetails',
    title: 'Card Details',
    iconType: 'nzIcon',
    icon: '../../../../assets/icon/credit-card.png',
    iconTheme: 'outline',
    submenu: [

    ]
  },

  {
    path: '/changesPassword',
    title: 'Change Password',
    iconType: 'nzIcon',
    icon: '../../../../assets/icon/lock.png',
    iconTheme: 'outline',
    submenu: [

    ]
  },
  {
    path: '/contactus',
    title: 'Contact Us',
    iconType: 'nzIcon',
    icon: '../../../../assets/icon/mail.png',
    iconTheme: 'outline',
    submenu: [

    ]
  },
]

export const ROUTES_players: SideNavInterface[] = [

  {

    path: '/team_edit_profile',
    title: 'Edit Profile',
    iconType: 'nzIcon',
    icon: '../../../../assets/icon/user-edit.png',
    iconTheme: 'outline',
    submenu: []
  },

  {
    path: '/manageOrders',
    title: 'Manage Orders',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: '../../../../assets/icon/manage-orders.png',
    submenu: []
  },
  // submenu: [
  //     {
  //         path: '',
  //         title: 'Create',
  //         iconType: 'nzIcon',
  //         icon: 'gold',
  //         iconTheme: 'outline',
  //         submenu: [

  //         ]
  //     },

  // ]
  // },

  {
    path: '/favouriteOrders_players',
    title: 'Favorite Orders',
    iconType: 'nzIcon',
    icon: '../../../../assets/icon/heart.png',
    iconTheme: 'outline',
    submenu: [

    ]
  },

  {
    path: '/cardDetails',
    title: 'Card Details',
    iconType: 'nzIcon',
    icon: '../../../../assets/icon/credit-card.png',
    iconTheme: 'outline',
    submenu: [

    ]
  },

  {
    path: '/changesPassword',
    title: 'Change Password',
    iconType: 'nzIcon',
    icon: '../../../../assets/icon/lock.png',
    iconTheme: 'outline',
    submenu: [

    ]
  },
  {
    path: '/contactus',
    title: 'Contact Us',
    iconType: 'nzIcon',
    icon: '../../../../assets/icon/mail.png',
    iconTheme: 'outline',
    submenu: [

    ]
  },
]

export const ROUTES_restaurant: SideNavInterface[] = [

  {

    path: '/restaurant_edit_profile',
    title: 'Edit Profile',
    iconType: 'nzIcon',
    icon: '../../../../assets/icon/user-edit.png',
    iconTheme: 'outline',
    submenu: []
  },

  {
    path: '/manageItems',
    title: 'Manage Items',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: '../../../../assets/icon/manage-orders.png',
    submenu: []
  },

  {
    path: '/bankingDetails',
    title: 'Banking Details',
    iconType: 'nzIcon',
    icon: '../../../../assets/icon/building-bank.png',
    iconTheme: 'outline',
    submenu: [

    ]
  },

  {
    path: '/paymentDetails',
    title: 'Payment Details',
    iconType: 'nzIcon',
    icon: '../../../../assets/icon/paymentReq.png',
    iconTheme: 'outline',
    submenu: [

    ]
  },





  {
    path: '/changesPassword',
    title: 'Change Password',
    iconType: 'nzIcon',
    icon: '../../../../assets/icon/lock.png',
    iconTheme: 'outline',
    submenu: [

    ]
  },
  {
    path: '/contactus',
    title: 'Contact Us',
    iconType: 'nzIcon',
    icon: '../../../../assets/icon/mail.png',
    iconTheme: 'outline',
    submenu: [

    ]
  },
]



